/**
 * Who pays an ERP accommodation reservation. Decides what the pay and
 * subcontractor forms may treat as Bonliva's cost and benefit tax:
 *
 * - `BonlivaPays` — Bonliva's cost, benefit-taxed (the behaviour before the
 *   field existed).
 * - `PayOnArrival` — the consultant pays the place; never a cost, never taxed.
 * - `DeductFromSalary` — the consultant pays the stay back through payroll: no
 *   benefit and no benefit tax; the whole amount (cost + extra cost) comes off
 *   net pay after tax as a salary deduction (Fortnox 9351). A subcontractor's
 *   consultant has no salary, so the SubcontractorForm keeps it as Bonliva's cost.
 * - `InvoiceSubcontractor` — Bonliva pays the place and charges the
 *   subcontractor; never taxed, off the PayForm, and shown on the
 *   SubcontractorForm among the costs Bonliva paid, marked as charged.
 */
export enum AccommodationPaymentMethod {
  BonlivaPays = "bonliva_pays",
  PayOnArrival = "pay_on_arrival",
  DeductFromSalary = "deduct_from_salary",
  InvoiceSubcontractor = "invoice_subcontractor"
}
